import { combineReducers } from "@reduxjs/toolkit";
import overviewBenefit from "./overview-benefit";

const overviewBenefitReducer = combineReducers({
  overviewBenefit,
});

export default overviewBenefitReducer;
